import { makeStyles } from '@material-ui/core'
import SuccessIcon from '@material-ui/icons/CheckCircleOutlineOutlined'
import ErrorIcon from '@material-ui/icons/ErrorOutlineOutlined'
import InfoIcon from '@material-ui/icons/InfoOutlined'
import WarningIcon from '@material-ui/icons/ReportProblemOutlined'
import { forwardRef } from 'react'
import { OsAlertVersion, Severities, Variants } from '../../core/Alert'
import { Icon } from '../../core/Icon'
import { useComponentVersion } from '../../hooks'
import { useTheme } from '../../theme'

interface AlertIconProps {
  severity?: Severities
  variant?: Variants
}

const Version1Icons = () => {
  return {
    warning: WarningIcon,
    error: ErrorIcon,
    info: InfoIcon,
    success: SuccessIcon,
  }
}

const getV2IconNames = (severity: Severities) => {
  switch (severity) {
    case 'info':
      return 'info'
    case 'success':
      return 'check_circle'
    case 'warning':
      return 'error'
    case 'error':
      return 'warning'
    default:
      return 'error'
  }
}

const v1Styles = makeStyles<any, { severity: Severities }>((theme) => ({
  icon: ({ severity }) => ({
    width: 22,
    height: 22,
    color: theme['alertIcon_' + severity],
    marginRight: 10,
  }),
}))

export const AlertIcon = forwardRef<SVGSVGElement, AlertIconProps>((props, ref) => {
  const { severity = 'info', variant = 'filled' } = props
  const theme = useTheme()
  let version = useComponentVersion('alert')
  const IconV1 = Version1Icons()[severity]

  switch (version) {
    case OsAlertVersion.V2:
      void ref
      return (
        <Icon
          color={variant === 'filled' ? theme.palette.white : undefined}
          size={'small'}
          style={{ marginRight: 8 }}
          icon={getV2IconNames(severity)}
        />
      )

    default:
      const classes1 = v1Styles({ severity })
      return <IconV1 ref={ref} className={classes1.icon} />
  }
})
